import { useEffect } from 'react'

import { useReRender } from './use-re-render'

export function useRenderAfterMount() {
    const reRender = useReRender()
    useEffect(reRender, [reRender])
}
